/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export enum SEARCH_BOX_FEATURES {
  RECENT_SEARCHES_FEATURE = 'recentSearches',
}
